// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Base styles using mobile-first approach */
.BottomBanner_bannerContainer__EOJkL {
  width: 100%;
  max-width: 1400px;
  margin: 20px auto;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
}

.BottomBanner_banner__CvP15 {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 600px;
}

.BottomBanner_bannerLeft__aafFX {
  width: 100%;
  background: #000000;
  position: relative;
  z-index: 2;
  padding: 20px;
  box-sizing: border-box;
  border-radius: 0;
  order: 2;
}

.BottomBanner_contentBox__0uEbD {
  position: relative;
  padding: 20px 0;
  color: #fff;
}

.BottomBanner_heading__RYt5X {
  font-size: 24px;
  font-weight: bold;
  margin: 0 0 10px;
  line-height: 1.2;
}

.BottomBanner_subheading__pLMe- {
  font-size: 16px;
  margin: 0 0 10px;
  color: #ccc;
  line-height: 1.4;
}

.BottomBanner_category__hlzBu {
  font-size: 14px;
  margin-bottom: 15px;
  color: #aaa;
}

.BottomBanner_btn__MsJds {
  display: inline-flex;
  align-items: center;
  background: red;
  color: white;
  border: none;
  padding: 12px 18px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  transition: background 0.3s ease;
  width: 100%;
  justify-content: center;
}

.BottomBanner_btn__MsJds:hover {
  background: darkred;
}

.BottomBanner_playIcon__wpHMi {
  margin-right: 8px;
  width: 20px;
  height: 20px;
}

.BottomBanner_bannerRight__0cRn3 {
  width: 100%;
  position: relative;
  height: 350px;
  order: 1;
}

.BottomBanner_episodeMainImage__fgjj8 {
  width: 100%;
  height: 509px;
  object-fit: cover;
}

.BottomBanner_optionsContainer__y6qnj {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  flex-direction: row;
  overflow-x: auto;
  padding: 15px;
  box-sizing: border-box;
  gap: 10px;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}

.BottomBanner_optionsContainer__y6qnj::-webkit-scrollbar {
  display: none;
}

.BottomBanner_option__YnThS {
  display: flex;
  flex: 0 0 auto;
  width: 200px;
  align-items: center;
  cursor: pointer;
  padding: 10px;
  border-radius: 5px;
  transition: all 0.3s ease;
  background: rgba(255, 255, 255, 0.1);
}

.BottomBanner_option__YnThS:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: translateY(-2px);
}

.BottomBanner_optionImage__FZtSz {
  width: 40px;
  height: 40px;
  object-fit: cover;
  border-radius: 5px;
  margin-right: 10px;
}

.BottomBanner_optionDetails__8Cojr {
  color: #fff;
}

.BottomBanner_optionTitle__PQEpk {
  font-size: 14px;
  font-weight: bold;
  margin: 0;
}

.BottomBanner_optionSubtitle__pAHuV {
  font-size: 12px;
  color: #ccc;
  margin: 4px 0 0;
}

/* Tablet styles */
@media (min-width: 768px) {
  .BottomBanner_bannerContainer__EOJkL {
    margin: 30px auto;
    width: 90%;
  }

  .BottomBanner_banner__CvP15 {
    flex-direction: row;
    min-height: 400px;
  }

  .BottomBanner_bannerLeft__aafFX {
    width: 40%;
    order: 1;
    border-radius: 10px;
    margin-right: -30px;
  }

  .BottomBanner_heading__RYt5X {
    font-size: 28px;
  }

  .BottomBanner_btn__MsJds {
    width: auto;
  }

  .BottomBanner_bannerRight__0cRn3 {
    width: 60%;
    order: 2;
    height: auto;
  }

  .BottomBanner_optionsContainer__y6qnj {
    right: 0;
    left: auto;
    top: 0;
    width: 250px;
    height: 100%;
    flex-direction: column;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .BottomBanner_option__YnThS {
    width: 100%;
  }
  
}

/* Desktop styles */
@media (min-width: 1024px) {
  .BottomBanner_bannerContainer__EOJkL {
    margin: 40px auto;
  }

  .BottomBanner_bannerLeft__aafFX {
    width: 35%;
    margin-right: -50px;
  }

  .BottomBanner_bannerRight__0cRn3 {
    width: 75%;
  }

  .BottomBanner_heading__RYt5X {
    font-size: 32px;
  }

  .BottomBanner_subheading__pLMe- {
    font-size: 18px;
  }

  .BottomBanner_optionsContainer__y6qnj {
    width: 280px;
  }

  .BottomBanner_option__YnThS {
    padding: 15px;
  }

  .BottomBanner_optionImage__FZtSz {
    width: 50px;
    height: 50px;
  }

  .BottomBanner_optionTitle__PQEpk {
    font-size: 16px;
  }

  .BottomBanner_optionSubtitle__pAHuV {
    font-size: 14px;
  }
}

/* Large desktop styles */
@media (min-width: 1440px) {
  .BottomBanner_bannerContainer__EOJkL {
    margin: 50px auto;
  }

  .BottomBanner_banner__CvP15 {
    min-height: 500px;
  }

  .BottomBanner_contentBox__0uEbD {
    padding: 30px 0;
  }

  .BottomBanner_heading__RYt5X {
    font-size: 36px;
  }

  .BottomBanner_subheading__pLMe- {
    font-size: 20px;
  }

  .BottomBanner_optionsContainer__y6qnj {
    width: 320px;
  }
}

/* Handle very small screens */
@media (max-width: 380px) {
  .BottomBanner_banner__CvP15 {
    min-height: 500px;
  }

  .BottomBanner_heading__RYt5X {
    font-size: 20px;
  }

  .BottomBanner_subheading__pLMe- {
    font-size: 14px;
  }

  .BottomBanner_option__YnThS {
    width: 160px;
  }

  .BottomBanner_optionImage__FZtSz {
    width: 35px;
    height: 35px;
  }
  .BottomBanner_episodeMainImage__fgjj8 {
    max-height: 300px !important;
  }
}
@media (max-width:480px) {
  .BottomBanner_banner__CvP15 {
    min-height: 400px;
  }

  .BottomBanner_heading__RYt5X {
    font-size: 18px;
  }

  .BottomBanner_subheading__pLMe- {
    font-size: 12px;
  }

  .BottomBanner_option__YnThS {
    width: 140px;
  }

  .BottomBanner_optionImage__FZtSz {
    width: 30px;
    height: 30px;
  }
  .BottomBanner_btn__MsJds {
    font-size: 12px;
  }
}

/* Handle landscape orientation on mobile */
@media (max-height: 500px) and (orientation: landscape) {
  .BottomBanner_banner__CvP15 {
    min-height: 300px;
  }

  .BottomBanner_contentBox__0uEbD {
    padding: 15px 0;
  }

  .BottomBanner_optionsContainer__y6qnj {
    padding: 10px;
  }

  .BottomBanner_option__YnThS {
    padding: 8px;
  }
  .BottomBanner_episodeMainImage__fgjj8 {
    max-height: 300px !important;
  }
  .BottomBanner_heading__RYt5X {
    font-size: 18px;
  }
  .BottomBanner_subheading__pLMe- {
    font-size: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/AudioSeries/Components/CSS/BottomBanner.module.css"],"names":[],"mappings":"AAAA,4CAA4C;AAC5C;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gCAAgC;EAChC,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE;IACE,iBAAiB;IACjB,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,UAAU;IACV,QAAQ;IACR,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;IACV,QAAQ;IACR,YAAY;EACd;;EAEA;IACE,QAAQ;IACR,UAAU;IACV,MAAM;IACN,YAAY;IACZ,YAAY;IACZ,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;AAEF;;AAEA,mBAAmB;AACnB;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,yBAAyB;AACzB;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;AACF;;AAEA,8BAA8B;AAC9B;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,4BAA4B;EAC9B;AACF;AACA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,eAAe;EACjB;AACF;;AAEA,2CAA2C;AAC3C;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Base styles using mobile-first approach */\n.bannerContainer {\n  width: 100%;\n  max-width: 1400px;\n  margin: 20px auto;\n  border-radius: 10px;\n  overflow: hidden;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);\n}\n\n.banner {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  min-height: 600px;\n}\n\n.bannerLeft {\n  width: 100%;\n  background: #000000;\n  position: relative;\n  z-index: 2;\n  padding: 20px;\n  box-sizing: border-box;\n  border-radius: 0;\n  order: 2;\n}\n\n.contentBox {\n  position: relative;\n  padding: 20px 0;\n  color: #fff;\n}\n\n.heading {\n  font-size: 24px;\n  font-weight: bold;\n  margin: 0 0 10px;\n  line-height: 1.2;\n}\n\n.subheading {\n  font-size: 16px;\n  margin: 0 0 10px;\n  color: #ccc;\n  line-height: 1.4;\n}\n\n.category {\n  font-size: 14px;\n  margin-bottom: 15px;\n  color: #aaa;\n}\n\n.btn {\n  display: inline-flex;\n  align-items: center;\n  background: red;\n  color: white;\n  border: none;\n  padding: 12px 18px;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 16px;\n  transition: background 0.3s ease;\n  width: 100%;\n  justify-content: center;\n}\n\n.btn:hover {\n  background: darkred;\n}\n\n.playIcon {\n  margin-right: 8px;\n  width: 20px;\n  height: 20px;\n}\n\n.bannerRight {\n  width: 100%;\n  position: relative;\n  height: 350px;\n  order: 1;\n}\n\n.episodeMainImage {\n  width: 100%;\n  height: 509px;\n  object-fit: cover;\n}\n\n.optionsContainer {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  background: rgba(0, 0, 0, 0.8);\n  display: flex;\n  flex-direction: row;\n  overflow-x: auto;\n  padding: 15px;\n  box-sizing: border-box;\n  gap: 10px;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: none;\n}\n\n.optionsContainer::-webkit-scrollbar {\n  display: none;\n}\n\n.option {\n  display: flex;\n  flex: 0 0 auto;\n  width: 200px;\n  align-items: center;\n  cursor: pointer;\n  padding: 10px;\n  border-radius: 5px;\n  transition: all 0.3s ease;\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.option:hover {\n  background: rgba(255, 255, 255, 0.2);\n  transform: translateY(-2px);\n}\n\n.optionImage {\n  width: 40px;\n  height: 40px;\n  object-fit: cover;\n  border-radius: 5px;\n  margin-right: 10px;\n}\n\n.optionDetails {\n  color: #fff;\n}\n\n.optionTitle {\n  font-size: 14px;\n  font-weight: bold;\n  margin: 0;\n}\n\n.optionSubtitle {\n  font-size: 12px;\n  color: #ccc;\n  margin: 4px 0 0;\n}\n\n/* Tablet styles */\n@media (min-width: 768px) {\n  .bannerContainer {\n    margin: 30px auto;\n    width: 90%;\n  }\n\n  .banner {\n    flex-direction: row;\n    min-height: 400px;\n  }\n\n  .bannerLeft {\n    width: 40%;\n    order: 1;\n    border-radius: 10px;\n    margin-right: -30px;\n  }\n\n  .heading {\n    font-size: 28px;\n  }\n\n  .btn {\n    width: auto;\n  }\n\n  .bannerRight {\n    width: 60%;\n    order: 2;\n    height: auto;\n  }\n\n  .optionsContainer {\n    right: 0;\n    left: auto;\n    top: 0;\n    width: 250px;\n    height: 100%;\n    flex-direction: column;\n    overflow-y: auto;\n    overflow-x: hidden;\n  }\n\n  .option {\n    width: 100%;\n  }\n  \n}\n\n/* Desktop styles */\n@media (min-width: 1024px) {\n  .bannerContainer {\n    margin: 40px auto;\n  }\n\n  .bannerLeft {\n    width: 35%;\n    margin-right: -50px;\n  }\n\n  .bannerRight {\n    width: 75%;\n  }\n\n  .heading {\n    font-size: 32px;\n  }\n\n  .subheading {\n    font-size: 18px;\n  }\n\n  .optionsContainer {\n    width: 280px;\n  }\n\n  .option {\n    padding: 15px;\n  }\n\n  .optionImage {\n    width: 50px;\n    height: 50px;\n  }\n\n  .optionTitle {\n    font-size: 16px;\n  }\n\n  .optionSubtitle {\n    font-size: 14px;\n  }\n}\n\n/* Large desktop styles */\n@media (min-width: 1440px) {\n  .bannerContainer {\n    margin: 50px auto;\n  }\n\n  .banner {\n    min-height: 500px;\n  }\n\n  .contentBox {\n    padding: 30px 0;\n  }\n\n  .heading {\n    font-size: 36px;\n  }\n\n  .subheading {\n    font-size: 20px;\n  }\n\n  .optionsContainer {\n    width: 320px;\n  }\n}\n\n/* Handle very small screens */\n@media (max-width: 380px) {\n  .banner {\n    min-height: 500px;\n  }\n\n  .heading {\n    font-size: 20px;\n  }\n\n  .subheading {\n    font-size: 14px;\n  }\n\n  .option {\n    width: 160px;\n  }\n\n  .optionImage {\n    width: 35px;\n    height: 35px;\n  }\n  .episodeMainImage {\n    max-height: 300px !important;\n  }\n}\n@media (max-width:480px) {\n  .banner {\n    min-height: 400px;\n  }\n\n  .heading {\n    font-size: 18px;\n  }\n\n  .subheading {\n    font-size: 12px;\n  }\n\n  .option {\n    width: 140px;\n  }\n\n  .optionImage {\n    width: 30px;\n    height: 30px;\n  }\n  .btn {\n    font-size: 12px;\n  }\n}\n\n/* Handle landscape orientation on mobile */\n@media (max-height: 500px) and (orientation: landscape) {\n  .banner {\n    min-height: 300px;\n  }\n\n  .contentBox {\n    padding: 15px 0;\n  }\n\n  .optionsContainer {\n    padding: 10px;\n  }\n\n  .option {\n    padding: 8px;\n  }\n  .episodeMainImage {\n    max-height: 300px !important;\n  }\n  .heading {\n    font-size: 18px;\n  }\n  .subheading {\n    font-size: 12px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bannerContainer": `BottomBanner_bannerContainer__EOJkL`,
	"banner": `BottomBanner_banner__CvP15`,
	"bannerLeft": `BottomBanner_bannerLeft__aafFX`,
	"contentBox": `BottomBanner_contentBox__0uEbD`,
	"heading": `BottomBanner_heading__RYt5X`,
	"subheading": `BottomBanner_subheading__pLMe-`,
	"category": `BottomBanner_category__hlzBu`,
	"btn": `BottomBanner_btn__MsJds`,
	"playIcon": `BottomBanner_playIcon__wpHMi`,
	"bannerRight": `BottomBanner_bannerRight__0cRn3`,
	"episodeMainImage": `BottomBanner_episodeMainImage__fgjj8`,
	"optionsContainer": `BottomBanner_optionsContainer__y6qnj`,
	"option": `BottomBanner_option__YnThS`,
	"optionImage": `BottomBanner_optionImage__FZtSz`,
	"optionDetails": `BottomBanner_optionDetails__8Cojr`,
	"optionTitle": `BottomBanner_optionTitle__PQEpk`,
	"optionSubtitle": `BottomBanner_optionSubtitle__pAHuV`
};
export default ___CSS_LOADER_EXPORT___;
